/* eslint-disable no-unused-vars */
var canRunAds = true;